import { Hero } from "./Hero";
import { WhoWeHelp } from "./WhoWeHelp";
import { ProblemSolution } from "./ProblemSolution";
import { Services } from "./Services";
import { WhyChooseUs } from "./WhyChooseUs";
import { TrustMetrics } from "./TrustMetrics";
import { Process } from "./Process";
import { Industries } from "./Industries";
import { Testimonials } from "./Testimonials";
import { MidCTA } from "./MidCTA";
import { BlogPreview } from "./BlogPreview";
import { FAQ } from "./FAQ";
import { BookCall } from "./BookCall";

export function HomePage() {
  return (
    <div className="flex flex-col">
      <Hero />
      <TrustMetrics />
      <WhoWeHelp />
      <ProblemSolution />
      <Services />
      <WhyChooseUs />
      <Process />
      <Industries />
      <Testimonials />
      <MidCTA />
      <BlogPreview />
      <FAQ />
      <BookCall />
    </div>
  );
}
